import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@shared/models/api-response.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LocationHttpService {

  constructor(private http: HttpClient) { }

  getByCoordinates(longtitude: string, latitude: string) {
    return this.http.get(`//geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=json&location=${longtitude},${latitude}`).pipe(
      map((res: any) => res['address'])
    );
  }

  // Blocked by CORS policy
  // getByIpAddress(ip_address: string) {
  //   return this.http.get(`//ipapi.co/${ip_address}/json`);
  // }

  getIpAddress(): Observable<any[]> {
    return this.http.get<ApiResponse>(`/getip`, { observe: 'response' }).pipe(
      map((res: HttpResponse<ApiResponse>) => {
        // Some upstreams append the same response header more than once; Angular surfaces that
        // as a single comma-separated string like "SG, SG". We only need one ISO code.
        const rawCountryCode = res.headers.get('X-Country-Code');
        const country_code = rawCountryCode
          ? rawCountryCode.split(',')[0].trim()
          : null;
        // Add country_code to the response data
        const responseData = res.body?.data?.rows || [];

        return { ...responseData, country_code };
      })
    );
  }
}
